var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.67 12.0441C21.5532 11.961 21.4159 11.9113 21.2729 11.9005C21.1299 11.8897 20.9866 11.9181 20.8586 11.9827C19.3441 12.7275 17.6325 12.9744 15.9689 12.6882C14.3053 12.4019 12.7751 11.5972 11.5973 10.3893C10.3879 9.21281 9.58229 7.68419 9.29588 6.02239C9.00946 4.36059 9.25693 2.65088 10.0028 1.13817C10.0655 1.01008 10.0924 0.867454 10.0806 0.725373C10.0687 0.583293 10.0187 0.447045 9.93571 0.331047C9.85273 0.215049 9.7399 0.123616 9.60916 0.0664235C9.47842 0.00923052 9.33463 -0.0115952 9.19302 0.00615016C7.75719 0.197772 6.37576 0.680662 5.13363 1.42515C3.89149 2.16963 2.81489 3.15998 1.96998 4.33533C0.599715 6.32577 -0.0882532 8.70602 0.00907096 11.1197C0.106395 13.5334 0.983775 15.8507 2.50985 17.7246C3.51749 18.9742 4.77625 19.9989 6.20487 20.7325C7.6335 21.4662 9.20025 21.8924 10.804 21.9838C13.4831 22.1313 16.1199 21.2682 18.1921 19.5657C20.2643 17.8631 21.6207 15.4452 21.9927 12.7909C22.0122 12.6488 21.9925 12.5042 21.9356 12.3725C21.8787 12.2409 21.7869 12.1273 21.67 12.0441Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.84e10905e8ec886cf15e9e1151f35038.svg";
export { ForwardRef as ReactComponent };